<template>
    <div>
        <vs-button color="suceess">
            featured
        </vs-button>
        <vs-prompt fullscreen @cancel="val=''" blur @accept="acceptAlert" @close="close" :active.sync="activePrompt"
            accept-text="Add" title="Add/Edit collection">
            <div class="con-exemple-prompt">
               poster: <input type="file" name="" id=""><hr>
               cover: <input type="file" name="" id="">
                <vs-input placeholder="Arabic Name" v-model="collection.ar_name" />
                <vs-input placeholder="English Name" v-model="collection.en_name" />

            </div>
        </vs-prompt>
       
        <vs-table :data="$store.state.collections.all.data" search stripe sst="true" @search="handleSearch">
            <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">

                 <div class="flex flex-wrap-reverse items-center">
                    <div @click="$router.push({name:'collectionsCreate'})"
                        class="p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-between text-lg font-medium text-base text-primary border border-solid border-primary">
                        <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
                        <span class="ml-2 text-base text-primary">Add New Collection</span>
                    </div>
                    <vs-button v-if="!featured"  color="warning" type="border" size="medium" @click="featured =true" class="mb-3">Featured Only</vs-button>
                    <vs-button v-if="featured"  color="success" type="filled" size="medium" @click="featured =false" class="mb-3">Featured Only</vs-button>
                </div>


            </div>
            <template #thead>
                <vs-th>Fatured</vs-th>
                <vs-th></vs-th>
                <vs-th>Arabic name</vs-th>
                <vs-th>English name</vs-th>
                <vs-th>Movies</vs-th>
                <vs-th>Series</vs-th>
                <vs-th>Actions</vs-th>
            </template>
            <template slot-scope="{data}">
                <tbody>
                    <vs-tr v-for="(collection,index) in data" :key="index">
                        <vs-td>
                        <vs-icon style="cursor: pointer;" v-if="collection.featured" icon="star" size="medium" color="warning" @click="featured_touch(collection)"></vs-icon>
                        <vs-icon style="cursor: pointer;"  v-if="!collection.featured" icon="star" size="medium"   @click="featured_touch(collection)"></vs-icon>
                        </vs-td>
                        <vs-td><img :src="`${$baseUrl}/uploads/collections/${collection.poster}`" width="80" alt=""></vs-td>
                        <vs-td>{{collection.ar_name}}</vs-td>
                        <vs-td>{{collection.en_name}}</vs-td>
                        <vs-td>{{collection.movies}}</vs-td>
                        <vs-td>{{collection.series}}</vs-td>
                        <vs-td class="whitespace-no-wrap">
                            <feather-icon icon="EditIcon" svgClasses="w-5 h-5 hover:text-primary stroke-current"
                                @click="edit(collection)" />
                            <feather-icon icon="TrashIcon" svgClasses="w-5 h-5 hover:text-danger stroke-current"
                                class="ml-2" @click="openConfirm(collection)" />
                        </vs-td>
                    </vs-tr>
                </tbody>
            </template>
        </vs-table>
        <vs-pagination :total="$store.state.collections.all.last_page" v-model="page"></vs-pagination>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                select1: 2,
                page:1,
                query:'',
                featured:false,
                activePrompt: false,
                delConfirm: false,
                val: '',
                def_collection: {
                    id: 0,
                    ar_name: '',
                    en_name: ''
                },
                collection: {
                    id: 0,
                    ar_name: '',
                    en_name: ''
                }
            }
        },
           watch: {
            page(val) {
                this.fetchData();
            },
            query(val) {
                this.fetchData();
            },
            featured(val) {
                this.fetchData();
            },
             

        },
        created() {
           this.fetchData()
        },
        methods: {
             handleSearch(searching) {
                this.query = searching;
            },
            fetchData(){
                var page=this.page;
                var query=this.query;
                var featured=this.featured?1:0;
              this.$store.dispatch('collections/fetchCollections',{page,query,featured})
            },
            openConfirm(collection) {
                this.collection=collection;
                this.$vs.dialog({
                    type: 'confirm',
                    color: 'danger',
                    title: `Delete collection`,
                    text: 'Are you sure to delete this item ?',
                    accept:this.del,
                    close:this.close
                })
            },
            acceptAlert(color) {
                const data = new FormData();
                data.append('id', this.collection.id);
                data.append('ar_name', this.collection.ar_name);
                data.append('en_name', this.collection.en_name);
                this.axios.post(`${this.$apiUrl}/collections`, data).then(res => {
                    this.collection = this.def_collection;
                    if (res.status == 200) {
                        this.$vs.notify({
                            color: 'success',
                            title: 'collection Addedd',
                            text: res.data.response.en_name
                        })
                    }
                    this.$store.dispatch('collections/fetchCollections')
                })

            },
            close() {
                this.collection = this.def_collection;
            },
            edit(collection) {
                this.collection = collection;
                this.activePrompt = true;
            },
            featured_touch(collection){
              this.axios.post(`${this.$apiUrl}/collections/${collection.id}/featured`).then(res => {
                    if (res.status == 200) {
                        this.$vs.notify({
                            color: 'success',
                            title: 'collection changed status  !',
                            text: res.data.response.en_name
                        })
                    }
                    this.fetchData();
                })
            },
            del() {
                 this.axios.post(`${this.$apiUrl}/collections/delete/${this.collection.id}`).then(res => {
                    this.collection = this.def_collection;
                    if (res.status == 200) {
                        this.$vs.notify({
                            color: 'warning',
                            title: 'collection Deleted !',
                            text:'to :'+res.data.response
                        })
                    }
                    this.$store.dispatch('collections/fetchCollections')
                })

            },
        }
    }
</script>
<style lang="scss">
    .con-exemple-prompt {
        padding: 10px;
        padding-bottom: 0px;

        .vs-input {
            width: 100%;
            margin-top: 10px;
        }

    }
</style>